export function Footer() {
    return (
        <>
            {/* Footer Section */}
            <footer className="bg-gray-100 py-2">
            </footer>
        </>
    )
}